import { ScoringSurveyPanelistsReadModel } from "@Evaluation/AlternativesSurveys/Domain/readmodels";

export class ScoringSurveyAccessLinksViewModel
{
    opened: boolean = false;

    surveyId: number | null = null;
    data: ScoringSurveyPanelistsReadModel | null = null;

    show(surveyId: number)
    {
        this.surveyId = surveyId;
        this.data = null;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.surveyId = null;
        this.data = null;
    }

    setData(data: ScoringSurveyPanelistsReadModel)
    {
        this.data = data;
    }
}